<template>
   <el-dialog
    title="发放国版币"
    :visible.sync="isVisible"
    width="900px"
    @close="handleClose">
    <el-form :model="packageForm" ref="form" :rules="rules" label-width="140px" :inline="false" >
      <el-form-item label="请输入用户手机号" prop="downloadTime" >
        <el-col :span="12">
         <el-input v-model="packageForm.downloadTime" placeholder="请输入"  clearable @change=""></el-input>
        </el-col>
        <el-col :span="11" :offset="1">
          <el-button type="primary"  @click="" size="small">查看用户信息</el-button>
        </el-col>
      </el-form-item>
      <el-form-item label="国版币" prop="type">
        <el-input v-model="packageForm.type"  placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="实付金额" prop="type">
        <el-input v-model="packageForm.type" type="number"  placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="authRange">
        <el-input v-model="packageForm.authRange" type="textarea"  placeholder='多种授权请用","隔开'></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="">确定</el-button>
    </span>
   </el-dialog>
   
</template>

<script>
export default {
  name: 'ManagementSideCreate',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      }
    }
  },
  data() {
    return {
       packageForm: {
        type: '',
        downloadTime: undefined,
        authRange: '',
        product: [{
          id: Math.random(),
          number:  undefined,
          price: undefined,
          totalPrice: ''
        }],
       },
       columns: [
          {
            id: 1,
            label: '数量（张）',
            prop: 'number',
          },
          {
            id: 2,
            label: '单价（元）',
            prop: 'price'
          },
          {
            id: 3,
            label: '总价（元）',
            prop: 'totalPrice'
          },
          {
            id: 4,
            label: '操作',
            prop: 'operation',
          }
        ],
        rules: {
          type: [
            { required: true, message: '套餐类型不能为空', trigger: 'blur' },
          ],
          downloadTime: [
            { required: true, message: '下载完成时间不能为空', trigger: 'blur' },
          ],
          authRange: [
            { required: true, message: '授权范围不能为空', trigger: 'blur' },
          ],
          product: [
            { required: true, message: '套餐产品不能为空', trigger: 'blur' },
          ],
        }
    };
  },

  mounted() {
    
  },

  methods: {
    handleClose() {
      this.isVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-input-number{
   width: 100% !important;
}
::v-deep .el-input-number .el-input__inner {
  text-align: left;
}
</style>